import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../App";
import { api } from "../api";
import { I } from "../Icons";

export default function LoginPage({ slug }) {
  const { login, dark, toggleDark, T } = useAuth();
  const navigate   = useNavigate();
  const isMaster   = !slug || slug === "admin";

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error,    setError]    = useState("");
  const [loading,  setLoading]  = useState(false);
  const [shake,    setShake]    = useState(false);

  // Agenda branding fetched by slug
  const [agendaName, setAgendaName] = useState("");
  const [logoUrl,    setLogoUrl]    = useState("");

  useEffect(() => {
    if (isMaster || !slug) return;
    api.getAgenda(slug)
      .then(data => {
        if (data.agenda) {
          setAgendaName(data.agenda.name || "");
          if (data.agenda.logoUrl) {
            const base = process.env.REACT_APP_API_URL || window.location.origin;
            const full = data.agenda.logoUrl.startsWith("http")
              ? data.agenda.logoUrl
              : `${base}${data.agenda.logoUrl}`;
            setLogoUrl(full);

            // Also update page favicon and apple-touch-icon
            const favicon = document.querySelector("link[rel~='icon']");
            if (favicon) favicon.href = full;
            const apple = document.querySelector("link[rel='apple-touch-icon']");
            if (apple) apple.href = full;
          }
          if (data.agenda.name) document.title = data.agenda.name;
        }
      })
      .catch(() => {});
  }, [slug, isMaster]);

  async function handleLogin() {
    if (!username || !password) { setError("Preencha usuario e senha."); return; }
    setLoading(true); setError("");
    try {
      await login(username, password, isMaster ? null : slug);
      navigate(isMaster ? "/admin" : `/${slug}`, { replace: true });
    } catch (e) {
      setError(e.message || "Erro ao entrar");
      setShake(true); setTimeout(() => setShake(false), 450);
    } finally { setLoading(false); }
  }

  const inp = {
    width:"100%", background:"rgba(255,255,255,0.07)", border:"1px solid rgba(255,255,255,0.13)",
    borderRadius:10, padding:"12px 14px 12px 42px", fontSize:14, color:"#f0f0f0", outline:"none",
  };

  return (
    <div style={{ minHeight:"100vh", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", background:"#0d0d0d", padding:24, position:"relative" }}>
      {/* Grid bg */}
      <div style={{ position:"absolute", inset:0, backgroundImage:"repeating-linear-gradient(0deg,transparent,transparent 48px,rgba(255,255,255,0.018) 48px,rgba(255,255,255,0.018) 49px),repeating-linear-gradient(90deg,transparent,transparent 48px,rgba(255,255,255,0.018) 48px,rgba(255,255,255,0.018) 49px)", pointerEvents:"none" }} />

      <button onClick={toggleDark} style={{ position:"absolute", top:16, right:16, background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.1)", borderRadius:8, padding:"6px 10px", cursor:"pointer", color:"#aaa", display:"flex" }}>
        <I n={dark?"Sun":"Moon"} size={17} />
      </button>

      <div style={{ animation:shake?"shake 0.4s":"none", width:"100%", maxWidth:340 }}>
        <div style={{ textAlign:"center", marginBottom:32 }}>

          {/* Logo â€” mostra o logo da banda se tiver, senÃ£o Ã­cone genÃ©rico */}
          {logoUrl ? (
            <img
              src={logoUrl}
              alt={agendaName}
              style={{ width:80, height:80, borderRadius:16, objectFit:"cover", margin:"0 auto 16px", display:"block", boxShadow:"0 4px 20px rgba(0,0,0,0.4)" }}
            />
          ) : (
            <div style={{ width:60, height:60, borderRadius:14, background:"rgba(26,86,219,0.13)", border:"1px solid rgba(79,142,247,0.25)", margin:"0 auto 16px", display:"flex", alignItems:"center", justifyContent:"center" }}>
              <I n="Music" size={28} style={{ color:"#4f8ef7" }} />
            </div>
          )}

          <div style={{ fontSize:20, fontWeight:900, color:"#f0f0f0", letterSpacing:1.5, textTransform:"uppercase" }}>
            {isMaster ? "MASTER ADMIN" : agendaName || "AGENDA DE SHOWS"}
          </div>
          <div style={{ fontSize:10, color:"#444", marginTop:5, letterSpacing:3, textTransform:"uppercase" }}>
            {isMaster ? "PAINEL DE CONTROLE" : "ACESSO INTERNO"}
          </div>
        </div>

        <div style={{ background:"rgba(255,255,255,0.035)", borderRadius:16, padding:"28px 24px", border:"1px solid rgba(255,255,255,0.07)" }}>
          <div style={{ position:"relative", marginBottom:10 }}>
            <span style={{ position:"absolute", left:13, top:"50%", transform:"translateY(-50%)", color:"#444", display:"flex" }}><I n="User" size={16} /></span>
            <input style={inp} placeholder="Usuario" value={username} onChange={e=>setUsername(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handleLogin()} autoComplete="username" />
          </div>
          <div style={{ position:"relative", marginBottom:8 }}>
            <span style={{ position:"absolute", left:13, top:"50%", transform:"translateY(-50%)", color:"#444", display:"flex" }}><I n="Lock" size={16} /></span>
            <input style={inp} placeholder="Senha" type="password" value={password} onChange={e=>setPassword(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handleLogin()} autoComplete="current-password" />
          </div>
          {error && <p style={{ color:"#f44336", fontSize:12, margin:"0 0 8px", textAlign:"center" }}>{error}</p>}
          <button onClick={handleLogin} disabled={loading} style={{ width:"100%", background:loading?"#555":"#1a56db", color:"#fff", border:"none", borderRadius:10, padding:13, fontSize:14, fontWeight:800, cursor:loading?"wait":"pointer", letterSpacing:1, marginTop:4 }}>
            {loading ? "ENTRANDO..." : "ENTRAR"}
          </button>
        </div>
      </div>
    </div>
  );
}
